import { AirLock, Equipment, EquipmentType, Extractor } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import EquipmentListItem from "./parts/EquipmentListItem/index.vue";
@Component({
  components: {
    EquipmentListItem,
  },
})
export default class EquipmentList extends Vue {
  @Prop() equipmentType!: EquipmentType;
  @Prop() equipmentList!: Equipment[];
  @Prop() categoryTitle!: string;
  @Prop() equipmentCount!: number;

  equipmentSelected(equipment: AirLock | Extractor | Equipment): void {
    this.$emit("equipmentSelected", equipment);
  }
}
